export const DEFAULT_CEILINGS_HEIGHT = 97
